import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  AiFillYoutube,
  AiOutlineClose,
  AiOutlineInstagram,
  AiOutlineMail,
  AiOutlineMenu,
} from "react-icons/ai";
import NLogo from "../images/N Logo.png";
import "../styles/Header.css";

const navLinks = [
  { to: "/", label: "Home", end: true },
  { to: "/work", label: "Work" },
  { to: "/business", label: "For Businesses" },
];

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={`siteHeader ${isMenuOpen ? "siteHeader--open" : ""}`}>
      <div className="siteHeader__inner">
        <NavLink className="siteHeader__brand" to="/" end onClick={closeMenu} aria-label="Nathan Coles Jr home">
          <img src={NLogo} width={44} height={44} className="siteHeader__logo" alt="" />
          <span>Nathan Coles Jr.</span>
        </NavLink>

        <button
          type="button"
          className="siteHeader__menuButton"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {isMenuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
        </button>

        <nav className="siteHeader__nav" aria-label="Primary">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              className={({ isActive }) => `siteHeader__navLink${isActive ? " siteHeader__navLink--active" : ""}`}
              to={link.to}
              end={link.end}
              onClick={closeMenu}
            >
              {link.label}
            </NavLink>
          ))}
          <a className="siteHeader__navLink" href="mailto:nathancolesjr@gmail.com" onClick={closeMenu}>
            Contact
          </a>
        </nav>

        <div className="siteHeader__socials">
          <a href="https://instagram.com/nathancolesjr" target="_blank" rel="noreferrer" aria-label="Instagram">
            <AiOutlineInstagram />
          </a>
          <a href="https://youtube.com/@cineteria" target="_blank" rel="noreferrer" aria-label="YouTube">
            <AiFillYoutube />
          </a>
          <a href="mailto:nathancolesjr@gmail.com" aria-label="Email">
            <AiOutlineMail />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
